// motion.ts — prefers-reduced-motion, read once.
//
// Exists for exactly one caller today: RailRow's arrival animation. The
// `@media (prefers-reduced-motion: reduce)` block in styles/index.css sets
// `animation: none` on `.animate-cc-slide`, which is correct (README
// §Motion) — but it means the CSS `animationend` event RailRow normally
// relies on to clear a thread out of `store.arrived` (see
// `onArrivedAnimationEnd` -> `store.clearArrived`) never fires for a
// reduced-motion user: no animation runs, so nothing ends. `store.arrived`
// is otherwise append-only (`markArrived`, and `releaseHeld` placing queued
// arrivals both add to it), so without this, `arrived` would grow by one
// unclearable entry per incoming thread for the whole session — silently,
// since the CSS renders the settled state either way and nothing looks
// wrong on screen (fix round 2, phase-2 whole-phase review re-review,
// finding 1).
//
// SSR- and jsdom-safe, same guard as viewport.ts's own `matches()`: no
// matchMedia means "not reduced motion", which is the safe default (the
// animation, or its immediate-clear substitute, simply doesn't special-case
// anything).
//
// Read once rather than subscribed to `change` (contrast with
// viewport.ts's `useIsMobile`, which does subscribe): a user flipping the
// OS reduced-motion toggle mid-session while a row happens to be mid-arrival
// is not a case worth a live listener for — the next arrival picks up
// whatever the preference is by then.
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false
}
